import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "idml-style-note"
}
const _hoisted_2 = {
  id: "merge-source",
  calss: "merge-source"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  id: "remove-merge-segment"
}
const _hoisted_5 = {
  key: 0,
  class: "paragraph-boundary"
}
const _hoisted_6 = { class: "boundary-text" }
const _hoisted_7 = {
  key: 0,
  id: "add-merge-segment"
}
const _hoisted_8 = {
  key: 0,
  class: "end-of-paragraph-message info"
}
const _hoisted_9 = {
  key: 1,
  class: "end-of-paragraph-message warning"
}
const _hoisted_10 = {
  key: 2,
  class: "end-of-paragraph-message warning"
}
const _hoisted_11 = {
  id: "merge-result",
  class: "merge-result"
}
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_SimpleSegment = _resolveComponent("SimpleSegment")!
  const _component_SegmentStatusIcon = _resolveComponent("SegmentStatusIcon")!
  const _component_ControlWrapper = _resolveComponent("ControlWrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.initailised)
    ? _withDirectives((_openBlock(), _createBlock(_component_ControlWrapper, {
        key: 0,
        "wrapper-title": _ctx.$t('mergeSegment.mergeSgments'),
        onConfirm: _ctx.saveMergeAction,
        onCancel: _ctx.closeMergeAction
      }, {
        default: _withCtx(() => [
          (_ctx.isIdml)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-symbols-outlined" }, "info", -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('mergeSegment.idmlStyleNote')), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('mergeSegment.sourceSegments')), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segmentsToMerge, (segment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: 'm'+segment.itemId
              }, [
                _createVNode(_component_SimpleSegment, {
                  modelValue: segment.data.sourceData,
                  "onUpdate:modelValue": ($event: any) => ((segment.data.sourceData) = $event),
                  "sample-segment": true
                }, {
                  default: _withCtx(() => [
                    (_ctx.showRemove(index))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_el_tooltip, {
                            placement: "top",
                            content: _ctx.removeTooltip,
                            "show-after": 10
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "default",
                                onClick: _ctx.removeLineAction
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('mergeSegment.remove')), 1)
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                (_ctx.showParagraphBoundary(index))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "boundary-line" }, null, -1)),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.endOfBlockInfoMessage), 1),
                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "boundary-line" }, null, -1))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createVNode(_component_el_tooltip, {
              placement: "top",
              content: _ctx.addTooltip,
              "show-after": 10
            }, {
              default: _withCtx(() => [
                (_ctx.showAddButton)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_el_button, {
                        type: "warning",
                        loading: _ctx.isLoadingContinuation,
                        onClick: _ctx.addLineAction
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('mergeSegment.add')), 1)
                        ]),
                        _: 1
                      }, 8, ["loading", "onClick"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["content"]),
            (_ctx.showParagraphEndInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "material-symbols-outlined" }, "info", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.endOfBlockInfoMessage), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showNoMoreSegments)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "material-symbols-outlined" }, "block", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('mergeSegment.noMoreSegments')), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.showParagraphEndBlock)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "material-symbols-outlined" }, "info", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.endOfBlockMessage), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('mergeSegment.mergeResult')), 1),
            _createVNode(_component_SimpleSegment, {
              modelValue: _ctx.mergedSourceData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mergedSourceData) = $event))
            }, {
              default: _withCtx(() => [
                (_ctx.resultSegmentTooLong(_ctx.mergedSourceData))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_SegmentStatusIcon)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["wrapper-title", "onConfirm", "onCancel"])), [
        [_directive_loading, _ctx.loading]
      ])
    : _createCommentVNode("", true)
}